import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  injectTellentAssistantActorGetter,
  injectTellentAssistantAuthTokenGetter,
  injectTellentAssistantThreadsBaseUrl,
} from './tellent-assistant-endpoint.provider';

export interface WorkflowResumeResponse {
  readonly runId: string;
  readonly status: 'suspended' | 'done' | 'error';
  readonly interruptId?: string;
  readonly reason?: string;
  readonly stepName?: string;
  readonly suspendPayload?: unknown;
  readonly output?: unknown;
  readonly error?: string;
}

@Injectable({ providedIn: 'root' })
export class TellentAssistantWorkflowHttp {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = injectTellentAssistantThreadsBaseUrl({ optional: true }) ?? '';
  private readonly getToken =
    injectTellentAssistantAuthTokenGetter({ optional: true }) ?? (() => null);
  private readonly getActor = injectTellentAssistantActorGetter({ optional: true }) ?? (() => null);

  public resume(
    workflowId: string,
    runId: string,
    stepName: string,
    resumeData: unknown,
  ): Observable<WorkflowResumeResponse> {
    return this.http.post<WorkflowResumeResponse>(
      `${this.baseUrl}/workflows/${encodeURIComponent(workflowId)}/resume/${encodeURIComponent(runId)}`,
      { stepName, resumeData },
      { headers: this.authHeaders() },
    );
  }

  private authHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = this.getToken();
    if (token) headers = headers.set('Authorization', token);
    const actor = this.getActor();
    if (actor) headers = headers.set('x-ts-actor', actor);
    return headers;
  }
}
